
import { TeamRecord } from '../types';

interface SortConfig {
  sortColumn: string;
  sortDirection: 'asc' | 'desc';
}

const calculateFormPoints = (formResults: string[]): number => {
  if (!formResults || formResults.length === 0) return 0;
  
  // Calculate points for the form (W=3, D=1, L=0)
  const points = formResults.reduce((total, result) => {
    switch (result) {
      case 'W': return total + 3;
      case 'D': return total + 1;
      case 'L': return total + 0;
      default: return total;
    }
  }, 0);

  // Return points normalized by the number of games to handle teams with different numbers of games
  return points;
};

export const sortLeagueTableData = (data: TeamRecord[], { sortColumn, sortDirection }: SortConfig) => {
  return [...data].sort((a, b) => {
    let comparison = 0;
    
    switch (sortColumn) {
      case 'form':
        const aFormPoints = calculateFormPoints(a.form || []);
        const bFormPoints = calculateFormPoints(b.form || []);
        
        // If form points are equal, use total points as a tiebreaker
        if (aFormPoints === bFormPoints) {
          comparison = b.points - a.points;
        } else {
          comparison = bFormPoints - aFormPoints;
        }
        break;
      case 'played':
        comparison = a.played - b.played;
        break;
      case 'wins':
        comparison = a.wins - b.wins;
        break;
      case 'draws':
        comparison = a.draws - b.draws;
        break;
      case 'losses':
        comparison = a.losses - b.losses;
        break;
      case 'goalsFor':
        comparison = a.goalsFor - b.goalsFor;
        break;
      case 'goalsAgainst':
        comparison = a.goalsAgainst - b.goalsAgainst;
        break;
      case 'goalDifference':
        comparison = a.goalDifference - b.goalDifference;
        break;
      case 'points':
        comparison = a.points - b.points;
        break;
      case 'ppg':
        comparison = a.ppg - b.ppg;
        break;
      case 'cleanSheets':
        comparison = a.cleanSheets - b.cleanSheets;
        break;
      case 'btts':
        comparison = a.btts - b.btts;
        break;
      case 'over15':
        comparison = a.over15 - b.over15;
        break;
      case 'over25':
        comparison = a.over25 - b.over25;
        break;
      case 'cards':
        // For cards, we'll calculate the average cards per game
        const aCardsPerGame = (a.yellowCards + a.redCards) / a.played;
        const bCardsPerGame = (b.yellowCards + b.redCards) / b.played;
        comparison = aCardsPerGame - bCardsPerGame;
        break;
      default:
        comparison = 0;
    }

    return sortDirection === 'asc' ? comparison : -comparison;
  });
};
